import React from "react";
import { ChevronDown, Phone } from "lucide-react";
import { firm, heroImage } from "../mock/mock";
import { Button } from "./ui/button";
import PaymentDialog from "./PaymentDialog";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#14213d] via-[#14213d]/90 to-[#14213d]/60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 pb-20">
        <div className="max-w-2xl">
          <span className="inline-block text-[#c8a15a] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-5">
            Crawfordsville, Indiana
          </span>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-6">
            Dedicated Legal Counsel You Can{" "}
            <span className="text-[#c8a15a]">Trust</span>
          </h1>
          <p className="text-slate-300 text-lg md:text-xl leading-relaxed mb-9 max-w-xl">
            {firm.name}, {firm.title} — experienced representation in criminal
            defense, family law, mediation, and civil litigation for the people
            of Montgomery County.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#contact">
              <Button className="w-full sm:w-auto bg-[#c8a15a] hover:bg-[#b58f45] text-[#14213d] font-semibold text-base px-8 py-6 rounded-md">
                Request a Consultation
              </Button>
            </a>
            <a href={firm.phoneHref} className="w-full sm:w-auto">
              <Button
                variant="outline"
                className="w-full sm:w-auto border-white/40 bg-white/5 text-white hover:bg-white hover:text-[#14213d] font-semibold text-base px-8 py-6 rounded-md gap-2"
              >
                <Phone size={18} /> {firm.phone}
              </Button>
            </a>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 text-slate-300">
            <div>
              <div className="text-[#c8a15a] font-display text-2xl font-bold">15+</div>
              <div className="text-sm">Years of Experience</div>
            </div>
            <div>
              <div className="text-[#c8a15a] font-display text-2xl font-bold">8</div>
              <div className="text-sm">Areas of Practice</div>
            </div>
            <div>
              <div className="text-[#c8a15a] font-display text-2xl font-bold">Partner</div>
              <div className="text-sm">Gobel Justice & Pyle</div>
            </div>
          </div>
        </div>
      </div>

      <a
        href="#practice"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 hover:text-[#c8a15a] transition-colors animate-bounce"
        aria-label="Scroll down"
      >
        <ChevronDown size={30} />
      </a>
    </section>
  );
};

export default Hero;
